export const normalizeAgencyIdsFromSnapshot = (value) => {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }

  if (typeof value === "object") {
    return Object.keys(value).filter(Boolean);
  }

  return [];
};
